module.exports = __webpack_public_path__ + "static/media/magic-bus-ngo-film.2580f6f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/magic-bus-ngo-film.jpg
// module id = 173
// module chunks = 0